<template>
  <div>
    <div class="page-wrapper chiller-theme toggled">
      <router-link
        id="show-sidebar"
        class="btn btn-sm btn-dark"
        :to="{ name: $route.name }"
      >
        <i class="fas fa-bars"></i>
      </router-link>
      <nav id="sidebar" class="sidebar-wrapper">
        <div class="sidebar-content">
          <div class="sidebar-brand">
            <!--                        <img :src="logo" class="navbar-brand-img" alt="...">-->
            <h2 class="logo-medsurlink">
              <img class="img-responsive" src="/img/brand/logo-white.png" />
            </h2>
            <div id="close-sidebar">
              <i class="fas fa-times ml-4"></i>
            </div>
          </div>
          <div class="sidebar-header">
            <div class="user-info">
              <span class="user-name">
                {{ user.prenom }}
                <strong> {{ user.nom }}</strong>
              </span>
              <span class="user-role">{{
                role == "Etablissement" ? institutionName : role
              }}</span>
              <span class="user-status">
                <i class="fa fa-circle"></i>
                <span>Online</span>
              </span>
            </div>
          </div>
          <div class="sidebar-menu">
            <ul>
              <li class="menu_item">
                <router-link
                  exact
                  :to="{ name: dashboardName }"
                  v-if="
                    can ||
                    hasAdminRole ||
                    ((hasPraticienRole ||
                      hasMedecinControleRole ||
                      hasAssistante) &&
                      userIsMed)
                  "
                >
                  <img
                    src="/img/icons/icone_navbar/tableau_bord.png"
                    class="img-fluid mr-3 image"
                    alt="Tableau de Bord"
                    width="30"
                  />
                  <span class="nav-link-text">
                    {{ $t("message.dashboard") }}</span
                  >
                </router-link>
              </li>
              <li class="menu_item">
                <router-link
                  exact
                  :to="{ name: dashboardName }"
                  v-if="hasSouscripteurRole"
                >
                  <img
                    src="/img/icons/icone_navbar/subscription.png"
                    class="img-fluid mr-2 image"
                    alt="Soucription"
                    width="30"
                  />
                  <span class="nav-link-text">
                    {{ $t("message.SouscripteurDashboard") }}</span
                  >
                </router-link>
              </li>
              <!-- <li class="menu_item" v-if="hasMedecinControleRole">
                <router-link :to="{ name: 'validations' }">
                  <img src="/img/icons/icone_navbar/validations.png" class="img-fluid mr-2 image" alt="Validations" width="30">
                  <span class="nav-link-text">
                      {{$t('message.validation')}}
                       <b-badge
                          pill
                          variant="danger"
                          style="font-size: 10px;"
                          v-if="getValidation() > 0"
                      >
                          {{ getValidation() }}
                      </b-badge> -->
              <!-- </span>
                </router-link>
              </li> -->
              <!-- <li class="menu_item" v-if="hasSouscripteurRole">
                <router-link exact :to="{ name: 'validations-prix' }">
                  <img src="/img/icons/icone_navbar/validations.png" class="img-fluid mr-2 image" alt="Validations-Prix" width="30">
                  <span class="nav-link-text">
                                        {{$t('message.validationPrix')}}
                                         <b-badge
                                            pill
                                            variant="danger"
                                            style="font-size: 10px;"
                                            v-if="getValidation() > 0"
                                        >
                                            {{ getValidation() }}
                                        </b-badge> -->
              <!-- </span>
                </router-link>
              </li>  -->
              <!-- <li class="menu_item">
                <router-link exact :to="{ name: 'PaiementPrestation' }" v-if="hasSouscripteurRole">
                  <img src="/img/icons/icone_navbar/facturations.png" class="img-fluid mr-2 image" alt="Prestation"  width="30">
                  <span class="nav-link-text">
                    {{
                    $t("message.PaiementPrestation")}}</span>
                </router-link>
              </li> -->

              <li class="menu_item">
                <router-link
                  :to="{ name: 'medical-file', params: { file: user.dossier } }"
                  v-if="hasPatientRole"
                >
                  <img
                    src="/img/icons/icone_navbar/dossier_medical.png"
                    class="img-fluid mr-1 image"
                    alt="Dossier medical"
                    width="30"
                  />
                  <span class="nav-link-text">
                    {{ $tc("message.medicalFile", 2) }}
                  </span>
                </router-link>
              </li>
              <li
                class="sidebar-dropdown menu_item"
                v-if="
                  can ||
                  ((hasPraticienRole ||
                    hasMedecinControleRole ||
                    hasAssistante) &&
                    userIsMed)
                "
              >
                <b-link :to="{ name: 'gestion-patient' }">
                  <img
                    src="/img/icons/icone_navbar/gestion_patient.png"
                    class="img-fluid mr-2 image"
                    alt="Gestion Patients"
                    width="30"
                  />
                  <span class="nav-link-text">{{
                    $tc("message.gestionPatient")
                  }}</span>
                </b-link>
                <div class="sidebar-submenu">
                  <ul>
                    <li
                      v-if="
                        can ||
                        ((hasPraticienRole || hasMedecinControleRole) &&
                          userIsMed) ||
                        hasAssistante
                      "
                    >
                      <router-link :to="{ name: 'MedecinPatient' }">
                        <i class="fas fa-user-md"></i>
                        <span class="nav-link-text">{{
                          $tc("message.medecinDossier", 2)
                        }}</span>
                      </router-link>
                    </li>
                    <li
                      v-if="
                        can ||
                        ((hasPraticienRole ||
                          hasMedecinControleRole ||
                          hasAssistante) &&
                          userIsMed)
                      "
                    >
                      <router-link :to="{ name: 'follow-up' }">
                        <i class="ni ni-tv-2 text-primary"></i>
                        <span class="nav-link-text">{{
                          $t("message.followUpPatient")
                        }}</span>
                      </router-link>
                    </li>
                    <li
                      v-if="
                        hasAdminRole ||
                        hasPraticienRole ||
                        hasMedecinControleRole ||
                        hasAssistante
                      "
                    >
                      <router-link :to="{ name: 'patients' }">
                        <i class="fas fa-user-injured"></i>
                        <span class="nav-link-text">{{
                          $tc("message.patients", 2)
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="hasGestionnaireRole">
                      <router-link
                        exact
                        :to="{ name: 'patient-medecin-controle' }"
                      >
                        <i class="fas fa-user-injured"></i>
                        <span class="nav-link-text">{{
                          $tc("message.patientMedecinControl", 2)
                        }}</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li
                class="menu_item"
                v-if="
                  can ||
                  hasAssistante ||
                  isComptable ||
                  (hasMedecinControleRole && userIsMed)
                "
              >
                <router-link :to="{ name: 'facturations' }">
                  <img
                    src="/img/icons/icone_navbar/facturations.png"
                    class="img-fluid mr-2 image"
                    alt="Facturations"
                    width="30"
                  />
                  <span class="nav-link-text">{{
                    $tc("message.facturations", 2)
                  }}</span>
                </router-link>
              </li>

              <!-- || hasGestionnaireRole -->
              <li
                class="menu_item"
                v-if="
                  (can && userIsMed) ||
                  ((hasPraticienRole ||
                    hasMedecinControleRole ||
                    hasAssistante) &&
                    userIsMed) ||
                  hasPatientRole ||
                  hasAssistante
                "
              >
                <router-link :to="{ name: 'appointments' }">
                  <img
                    src="/img/icons/icone_navbar/rendez_vous.png"
                    class="img-fluid mr-2 image"
                    alt="Rendez-vous"
                    width="30"
                  />
                  <span class="nav-link-text">{{
                    $tc("message.appointments", 2)
                  }}</span>
                </router-link>
              </li>

              <li
                class="menu_item"
                v-if="
                  hasPraticienRole || hasMedecinControleRole || hasAssistante
                "
              >
                <router-link :to="{ name: 'medical-advice' }">
                  <img
                    src="/img/icons/icone_navbar/avis_medicaux.png"
                    class="img-fluid mr-2 image"
                    alt="Avis Médicaux"
                    width="30"
                  />
                  <span class="nav-link-text">
                    {{ $t("message.medicalAdvice") }}
                    <b-badge
                      pill
                      variant="danger"
                      style="font-size: 10px"
                      v-if="getUnrespondedMedicalAdvice() > 0"
                    >
                      {{ getUnrespondedMedicalAdvice() }}
                    </b-badge>
                  </span>
                </router-link>
              </li>
              <!-- 
              <li class="sidebar-dropdown menu_item">
                <router-link :to="{ name: 'mobile' }">
                  <img
                    src="/img/icons/icone_navbar/gestion_user.png"
                    class="img-fluid mr-2 image"
                    alt=" Medsurlink Mobile"
                    width="30"
                  />
                  <span class="nav-link-text">
                    {{ $t("message.mobile.title") }}</span
                  >
                </router-link>
                <div class="sidebar-submenu">
                  <ul>
                    <li>
                      <router-link :to="{ name: 'prestataires' }">
                        <img
                          src="/img/icons/icone_navbar/avis_medicaux.png"
                          class="img-fluid mr-2 image"
                          alt="Avis Médicaux"
                          width="30"
                        />
                        <span class="nav-link-text">
                          {{ $t("message.mobile.prestataire") }}
                          <b-badge
                            pill
                            variant="danger"
                            style="font-size: 10px"
                            v-if="getUnrespondedMedicalAdvice() > 0"
                          >
                            {{ getUnrespondedMedicalAdvice() }}
                          </b-badge>
                        </span>
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'etablissements' }">
                        <img
                          src="/img/icons/icone_navbar/avis_medicaux.png"
                          class="img-fluid mr-2 image"
                          alt="Avis Médicaux"
                          width="30"
                        />
                        <span class="nav-link-text">
                          {{ $t("message.mobile.etablissement") }}
                          <b-badge
                            pill
                            variant="danger"
                            style="font-size: 10px"
                            v-if="getUnrespondedMedicalAdvice() > 0"
                          >
                            {{ getUnrespondedMedicalAdvice() }}
                          </b-badge>
                        </span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li> -->

              <li
                class="menu_item"
                v-if="(hasMedecinControleRole && userIsMed) || hasAssistante"
              >
                <router-link :to="{ name: 'etablissement-prices' }">
                  <img
                    src="/img/icons/icone_navbar/Etablissement_prix.png"
                    class="img-fluid mr-2 image"
                    alt="Etablissement Prix"
                    width="30"
                  />
                  <span class="nav-link-text">
                    {{ $t("message.EtablissementPrix") }}
                  </span>
                </router-link>
              </li>
              <li class="menu_item">
                <router-link
                  :to="{ name: 'payment-management' }"
                  v-if="hasGestionnaireRole || hasAdminRole || hasAssistante"
                >
                  <img
                    src="/img/icons/icone_navbar/gestion_affil.png"
                    class="img-fluid mr-2 image"
                    alt="Gestion des paiements"
                    width="30"
                  />
                  <span class="nav-link-text">{{
                    $tc("message.gestionaffiliation", 2)
                  }}</span>
                </router-link>
              </li>

              <li class="menu_item" v-if="hasAdminRole">
                <router-link :to="{ name: 'prospect-assurances' }">
                  <i class="ni ni-tv-2 text-primary"></i>
                  <span class="nav-link-text">{{
                    $tc("message.prospect_assurances", 2)
                  }}</span>
                </router-link>
              </li>

              <li
                class="sidebar-dropdown menu_item"
                v-if="
                  can ||
                  hasPraticienRole ||
                  hasMedecinControleRole ||
                  hasAssistante
                "
              >
                <router-link :to="{ name: 'user-management' }">
                  <img
                    src="/img/icons/icone_navbar/gestion_user.png"
                    class="img-fluid mr-2 image"
                    alt="Gestion des Utilisateurs"
                    width="30"
                  />
                  <span class="nav-link-text">{{
                    $t("message.userManagement")
                  }}</span>
                </router-link>
                <div class="sidebar-submenu">
                  <ul>
                    <li
                      v-if="
                        hasMedecinControleRole ||
                        hasAssistante ||
                        hasAdminRole ||
                        hasGestionnaireRole
                      "
                    >
                      <router-link :to="{ name: 'managers' }">
                        <i class="fas fa-users-cog"></i>
                        <span class="nav-link-text">{{
                          $tc("message.managers", 2)
                        }}</span>
                      </router-link>
                    </li>
                    <li
                      v-if="
                        (can && userIsMed) ||
                        ((hasPraticienRole ||
                          hasMedecinControleRole ||
                          hasAssistante) &&
                          userIsMed)
                      "
                    >
                      <router-link :to="{ name: 'subscribers' }">
                        <i class="fas fa-user"></i>
                        <span class="nav-link-text">{{
                          $tc("message.subscribers", 2)
                        }}</span>
                      </router-link>
                    </li>
                    <li
                      v-if="
                        can ||
                        hasPraticienRole ||
                        hasMedecinControleRole ||
                        hasAssistante
                      "
                    >
                      <router-link :to="{ name: 'patients' }">
                        <i class="fas fa-user-injured"></i>
                        <span class="nav-link-text">{{
                          $tc("message.patients", 2)
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="can">
                      <router-link :to="{ name: 'control-doctors' }">
                        <i class="fas fa-user-md"></i>
                        <span class="nav-link-text">{{
                          $tc("message.controlDoctors", 2)
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="can">
                      <router-link :to="{ name: 'practitioners' }">
                        <i class="fas fa-user-nurse"></i>
                        <span class="nav-link-text">{{
                          $tc("message.practitioners", 2)
                        }}</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="sidebar-dropdown menu_item" v-if="can">
                <b-link :to="{ name: 'admin-management' }">
                  <img
                    src="/img/icons/icone_navbar/gestion_admin.png"
                    class="img-fluid mr-2 image"
                    alt="Gestion Administrative"
                    width="30"
                  />
                  <span class="nav-link-text">{{
                    $t("message.adminManagement")
                  }}</span>
                </b-link>
                <div class="sidebar-submenu">
                  <ul>
                    <li>
                      <router-link
                        :to="toMedicalFile('generale')"
                        v-if="hasGestionnaireRole || hasAdminRole"
                      >
                        <i class="fas fa-file-medical-alt"></i>
                        <span class="nav-link-text">{{
                          $tc("message.medicalFiles", 2)
                        }}</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'affiliations' }"
                        v-if="hasGestionnaireRole || hasAdminRole"
                      >
                        <i class="fas fa-link"></i>
                        <span class="nav-link-text">{{
                          $tc("message.affiliations", 2)
                        }}</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'professions' }"
                        v-if="hasGestionnaireRole || hasAdminRole"
                      >
                        <i class="fas fa-user-tie"></i>
                        <span class="nav-link-text">{{
                          $tc("message.professions", 2)
                        }}</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'specialties' }"
                        v-if="hasGestionnaireRole || hasAdminRole"
                      >
                        <i class="fas fa-briefcase-medical"></i>
                        <span class="nav-link-text">{{
                          $tc("message.specialties", 2)
                        }}</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'institutions' }"
                        v-if="hasGestionnaireRole || hasAdminRole"
                      >
                        <i class="fas fa-clinic-medical"></i>
                        <span class="nav-link-text">{{
                          $tc("message.institutions", 2)
                        }}</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'drugs' }"
                        v-if="hasGestionnaireRole || hasAdminRole"
                      >
                        <i class="fas fa-tablets"></i>
                        <span class="nav-link-text">{{
                          $tc("message.drug", 2)
                        }}</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li
                class="sidebar-dropdown menu_item"
                v-if="
                  hasPraticienRole || hasMedecinControleRole || hasAssistante
                "
              >
                <b-link :to="{ name: 'dossier-management' }">
                  <img
                    src="/img/icons/icone_navbar/dossier_medical.png"
                    class="img-fluid mr-2 image"
                    alt="Dossier medical"
                    width="30"
                  />
                  <span class="nav-link-text">{{
                    $t("message.medicalManagement")
                  }}</span>
                </b-link>
                <div class="sidebar-submenu">
                  <ul>
                    <li v-if="hasFile">
                      <router-link :to="toMedicalFile('generale')">
                        <i class="fas fa-stethoscope"></i>
                        <span class="nav-link-text">{{
                          $tc("message.medicalFiles", 1)
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="hasSouscripteurRole">
                      <router-link :to="{ name: 'mesAffilies' }">
                        <i class="ni ni-tv-2 text-primary"></i>
                        <span class="nav-link-text">{{
                          $tc("message.mesAffilie")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="hasMedecinControleRole || hasAssistante">
                      <router-link :to="{ name: 'medical-management' }">
                        <i class="fas fa-notes-medical text-green"></i>
                        <span class="nav-link-text">{{
                          $t("message.gestionmedical")
                        }}</span>
                      </router-link>
                    </li>

                    <li
                      class="header-menu"
                      v-if="
                        isDefine('consultations_obstetrique') ||
                        isDefine('consultations_medecine') ||
                        isDefine('cardiologies')
                      "
                    >
                      <span>{{ $tc("message.consultations", 2) }}</span>
                    </li>

                    <li
                      v-if="isDefine('consultations_obstetrique') && isFemale"
                    >
                      <router-link :to="toMedicalFile('obstetric')">
                        <i class="fas fa-stethoscope"></i>
                        <span class="nav-link-text">{{
                          $tc("message.obstetric", 2)
                        }}</span>
                      </router-link>
                    </li>

                    <li v-if="isDefine('consultations_medecine')">
                      <router-link :to="toMedicalFile('generale')">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $tc("message.general", 2)
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologies')">
                      <router-link :to="toMedicalFile('cardiologie')">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.cardiology")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('consultations_manuscrites')">
                      <router-link :to="toMedicalFile('fichiersExternes')">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.manuscrit")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.endocrinology")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.gastroenterology")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.geriatrics")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.hématologie")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.internalMedicine")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.nephrology")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.neurology")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.ophthalmology")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.oncology")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.earNoseThroat")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link tag="" :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.pediatrics")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.pneumology")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.psychiatry")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.rheumatology")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('cardiologie')">
                      <router-link :to="{ name: $route.name }">
                        <i class="fas fa-file-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.stomatology")
                        }}</span>
                      </router-link>
                    </li>

                    <li class="header-menu" v-if="isDefine('hospitalisations')">
                      <span>Hospitalisation</span>
                    </li>
                    <li v-if="isDefine('hospitalisations')">
                      <router-link
                        :to="toMedicalFile($tc('message.hospitalisations', 1))"
                      >
                        <i class="fas fa-hospital"></i>
                        <span class="nav-link-text">{{
                          $tc("message.hospitalisations", 2)
                        }}</span>
                      </router-link>
                    </li>

                    <li
                      class="header-menu"
                      v-if="
                        isDefine('resultats_labo') ||
                        isDefine('resultats_imagerie')
                      "
                    >
                      <span>{{ $tc("message.results", 2) }}</span>
                    </li>
                    <li v-if="isDefine('resultats_labo')">
                      <router-link :to="toMedicalFile('resultatLabo')">
                        <i class="fas fa-notes-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.laboratory")
                        }}</span>
                      </router-link>
                    </li>
                    <li v-if="isDefine('resultats_imagerie')">
                      <router-link :to="toMedicalFile('resultatImagerie')">
                        <i class="fas fa-notes-medical"></i>
                        <span class="nav-link-text">{{
                          $t("message.imagery")
                        }}</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="menu_item">
                <router-link
                  exact
                  :to="{ name: 'mesAffilies' }"
                  v-if="hasSouscripteurRole"
                >
                  <img
                    src="/img/icons/icone_navbar/dossier_medical.png"
                    class="img-fluid mr-2 image"
                    alt="Mes Affiliés"
                    width="30"
                  />
                  <span class="nav-link-text">
                    {{ $tc("message.mesAffilie", 2) }}</span
                  >
                </router-link>
              </li>
              <li class="menu_item" v-can="'Listing des alertes'">
                <router-link exact :to="{ name: 'alertes' }">
                  <img
                    src="/img/icons/icone_navbar/alerte.png"
                    class="img-fluid mr-2 image"
                    alt="Alertes"
                    width="30"
                  />
                  <span class="nav-link-text">
                    Alertes
                    <!-- span class="badge badge-danger bg-white">3</span>  -->
                  </span>
                </router-link>
              </li>
              <li class="menu_item">
                <router-link
                  exact
                  :to="{ name: 'notifications' }"
                  v-if="
                    hasSouscripteurRole ||
                    hasAssistante ||
                    hasPatientRole ||
                    hasMedecinControleRole
                  "
                >
                  <img
                    src="/img/icons/icone_navbar/notification.png"
                    class="img-fluid mr-2 image"
                    alt="Notifications"
                    width="30"
                  />
                  <span class="nav-link-text">
                    Notifications
                    <!-- span class="badge badge-danger bg-white">3</span>  -->
                  </span>
                </router-link>
              </li>
              <li
                class="sidebar-dropdown menu_item"
                v-if="hasMedecinControleRole || hasAssistante"
              >
                <router-link :to="{ name: 'activite-management' }">
                  <img
                    src="/img/icons/icone_navbar/gestion_act.png"
                    class="img-fluid mr-2 image"
                    alt="Gestion des activités"
                    width="30"
                  />
                  <span class="nav-link-text">{{
                    $t("message.activiteManagement")
                  }}</span>
                </router-link>
              </li>
              <li
                class="menu_item"
                v-if="hasMedecinControleRole || hasAssistante"
              >
                <router-link exact :to="{ name: 'TrajetDashboard' }">
                  <img
                    src="/img/icons/icone_navbar/parcours_soins.png"
                    class="img-fluid mr-2 image"
                    alt="Parcours de soins"
                    width="30"
                  />
                  <span class="nav-link-text">{{ $t("message.Trajet") }}</span>
                </router-link>
              </li>
              <li
                class="menu_item"
                v-if="hasMedecinControleRole || hasAssistante"
              >
                <router-link exact :to="{ name: 'PriseEnCharge' }">
                  <img
                    src="/img/icons/icone_navbar/care.png"
                    class="img-fluid mr-2 image"
                    alt="Prise en Charge"
                    width="30"
                  />
                  <span>{{ $t("message.takeCare") }}</span>
                </router-link>
              </li>
              <li
                class="menu_item"
                v-can="'Administrer les roles & permissions'"
              >
                <router-link exact :to="{ name: 'gestion-des-rgbac' }">
                  <img
                    src="/img/icons/icone_navbar/care.png"
                    class="img-fluid mr-2 image"
                    alt="rgbac"
                    width="30"
                  />
                  <span>{{ $t("message.rgbac") }}</span>
                </router-link>
              </li>
              <li
                class="hidden-logout"
                v-if="
                  hasMedecinControleRole ||
                  hasAssistante ||
                  hasSouscripteurRole ||
                  hasPraticienRole ||
                  hasPatientRole ||
                  hasAdminRole ||
                  hasGestionnaireRole
                "
              >
                <b-link @click="logOut">
                  <img
                    src="/img/icons/icone_navbar/disconnexion.png"
                    class="img-fluid mr-2 image"
                    alt="Déconnexion"
                    width="30"
                  />
                  <span>{{ $t("message.logout") }}</span>
                </b-link>
              </li>
            </ul>
          </div>
          <!-- sidebar-menu  -->
        </div>
        <!-- sidebar-content  -->
      </nav>
      <!-- sidebar-wrapper  -->
    </div>
  </div>
  <!-- page-wrapper -->
</template>
<script>
import NavbarToggleButton from "@/components/NavbarToggleButton";
import AppConfig from "../../constants/AppConfig";
import { mapGetters } from "vuex";
import $ from "jquery";
import _ from "lodash";

export default {
  name: "sidebar",
  computed: {
    ...mapGetters([
      "file",
      "hasAdminRole",
      "hasMedecinControleRole",
      "hasPatientRole",
      "hasPraticienRole",
      "hasSouscripteurRole",
      "hasGestionnaireRole",
      "isComptable",
      "hasAssistante",
      "customUserRoles",
      "messages",
      "validation_count",
      "medicalAdvices",
      "userInstitutions",
    ]),
    institutionName: function () {
      if (!_.isUndefined(this.userInstitutions)) {
        if (this.userInstitutions.length > 0) {
          return this.userInstitutions[0].name;
        }
        return "";
      }
    },
    can: function () {
      return (
        this.hasAdminRole ||
        this.hasGestionnaireRole ||
        this.hasMedecinControleRole ||
        this.hasAssistante
      );
    },

    userIsMed: function () {
      return JSON.parse(localStorage.getItem("user"))["isMedicasure"];
    },

    canNot: function () {
      return !this.hasGestionnaireRole;
    },

    isFemale: function () {
      if (!_.isUndefined(this.file.patient)) {
        return this.file.patient.sexe == "F";
      }
      return false;
    },

    hasFile: function () {
      if (!_.isUndefined(this.file)) {
        return !_.isEmpty(this.file);
      }
      return false;
    },
  },
  components: {
    NavbarToggleButton,
  },
  props: {
    logo: {
      type: String,
      default: AppConfig.baseUrl + "/img/brand/logo-blanc.png",
      description: "Sidebar app logo",
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item",
    },
  },
  data() {
    return {
      //avatar: AppConfig.baseUrl + '/img/theme/team-1-800x800.jpg'
      avatar: AppConfig.baseUrl + "/img/theme/default-user.png",
      user: JSON.parse(localStorage.getItem("user")),
      role: localStorage.getItem("role"),
      dashboardName: localStorage.getItem("dashboardName"),
      reveleSide: false,
    };
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    getUserInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit,
      };

      this.$store.dispatch("getUserInstitutions", { args: args });
    },

    getUnrespondedMedicalAdvice() {
      let unrespondedMedicalAdvice = 0;

      // To prevent error
      if (!this.medicalAdvices) {
        return null;
      }

      // Loop through medical advices
      this.medicalAdvices.forEach((medicalAdvice) => {
        // If medecin_avis exists in order to avoid error
        if (medicalAdvice.medecin_avis) {
          // Loop through medecins of medical advices
          medicalAdvice.medecin_avis.forEach((adviceDoctor) => {
            // If the current user if one of medecin
            if (adviceDoctor.medecin_id === this.user.id) {
              // If he/she did not responded to medical advice
              if (!adviceDoctor.avis) unrespondedMedicalAdvice++;
            }
          });
        }
      });

      return unrespondedMedicalAdvice;
    },
    getUnrespondedValidation() {
      let unrespondedMedicalAdvice = 0;
      if (!this.messages) {
        return null;
      }
      this.messages.forEach((message) => {
        if (message.view === 1) {
          unrespondedMedicalAdvice++;
        }
      });

      return unrespondedMedicalAdvice;
    },
    getValidation() {
      return this.validation_count;
    },
    isDefine(item) {
      if (!_.isEmpty(this.file)) {
        if (this.file.hasOwnProperty(item)) {
          return this.file[item].length > 0;
        }
        return false;
      }
      return false;
    },

    toSelectedMedicalFile() {
      return this.$router.resolve({
        name: "medical-file",
        params: { file: this.file.slug },
      }).href;
    },

    toMedicalFile(item) {
      let result = this.$route.fullPath.includes(item);
      if (result) {
        if ($("#" + item).length) {
          document.getElementById(item).scrollIntoView(top);
        }
      }

      return (
        this.$router.resolve({
          name: "medical-file",
          params: { file: this.file.slug },
        }).href +
        "#" +
        item
      );
    },

    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },

    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },

    logOut() {
      let args = {
        user: localStorage.getItem("user"),
      };

      let successMessage = this.$i18n.t("message.logoutSuccess");
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
      };
      this.$store.dispatch("logoutHandler", {
        args,
        errorMessages,
        successMessage,
      });
    },
    getValidationExamensCount() {
      this.$store.dispatch("getValidationExamensCount", { args: {} });
    },
    getValidationExamensPrix() {
      this.$store.dispatch("getExamenValidationPrix", { args: {} });
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
  mounted() {
    this.$store.dispatch("getCustomUserRoles");

    if (
      this.isComptable &&
      !this.hasMedecinControleRole &&
      !this.hasPraticienRole &&
      !this.hasGestionnaireRole &&
      !this.hasAssistante
    ) {
      this.getUserInstitutions();
    }

    if (this.hasSouscripteurRole || this.hasMedecinControleRole) {
      this.getValidationExamensCount();
    }

    $("#close-sidebar").click(function (e) {
      e.preventDefault();
      $(".page-wrapper").removeClass("toggled");
      $(".main-content").removeClass("reculer");
    });

    $("#show-sidebar").click(function (e) {
      e.preventDefault();
      $(".page-wrapper").addClass("toggled");
      $(".main-content").addClass("reculer");
    });

    if ($(window).width() <= 768) {
      $(".page-wrapper").removeClass("toggled");
      $(".main-content").removeClass("reculer");
      $("#show-sidebar").click(function () {
        // sidebar.style.display = 'block';
        $(".page-wrapper").addClass("toggled");
        $(".main-content").addClass("reculer");
      });
      $("#close-sidebar").click(function () {
        // sidebar.style.display = 'none';
        $(".page-wrapper").removeClass("toggled");
        $(".main-content").removeClass("reculer");
      });

      $(".sidebar-dropdown").click(function () {
        // e.preventDefault();
        $(".page-wrapper").removeClass("toggled");
        $(".main-content").removeClass("reculer");
      });

      $(".sidebar-menu").click(function () {
        // e.preventDefault();
        $(".page-wrapper").removeClass("toggled");
        $(".main-content").removeClass("reculer");
      });

      $("d-wrapper").click(function () {
        $(".page-wrapper").removeClass("toggled");
        $(".main-content").removeClass("reculer");
      });
    }

    if ($(window).width() > 768) {
      $(".page-wrapper").addClass("toggled");
      $(".main-content").addClass("reculer");
    }

    $(document).ready(function () {
      $("ul li a").click(function () {
        $("li a").removeClass("actives");
        $(this).addClass("actives");
      });
    });
  },
};
</script>
